import { DataGrid, GridColDef } from '@mui/x-data-grid';
import React, { FunctionComponent } from 'react';

import {
  FolkloreType,
  TinderSuperLikedUsersQuery,
} from '../../../../../apollo/__generated__/graphql';
import { folkloreNameByFolklore } from '../../../../../user/services/user.service';
import { useTinderSuperLikedUsersQuery } from '../../../../hooks/useTinderSuperLikedUsersQuery';

interface TinderSuperLikedUsersTabProps {
  eventId: string;
}

const columns: GridColDef<
  TinderSuperLikedUsersQuery['tinderSuperLikedUsers'][number]
>[] = [
  {
    field: 'tinderSuperLikeCount',
    headerName: 'Super Likes',
  },
  {
    field: 'firstname',
    headerName: 'Nom',
    width: 150,
    renderCell: (params) =>
      `${params.row.firstname} ${params.row.lastname?.substring(0, 1)}.`,
  },
  {
    field: 'nickname',
    headerName: 'Surnom',
    width: 150,
  },
  {
    field: 'folklore',
    headerName: 'Folklore',
    renderCell: (params) =>
      folkloreNameByFolklore[params.row.folklore ?? FolkloreType.Other],
    width: 100,
  },
  {
    field: 'studyTown',
    headerName: 'Ville',
    width: 150,
  },
  {
    field: 'studies',
    headerName: 'Fillière',
    width: 150,
  },
];

export const TinderSuperLikedUsersTab: FunctionComponent<
  TinderSuperLikedUsersTabProps
> = ({ eventId }) => {
  const { data: userTargetsData, loading } =
    useTinderSuperLikedUsersQuery(eventId);

  return (
    <DataGrid
      rows={userTargetsData?.tinderSuperLikedUsers ?? []}
      columns={columns}
      loading={loading}
    />
  );
};
